import {
    Component
    , Input
    , Output
    , EventEmitter
    , HostListener
    , OnInit
    , OnChanges
    , SimpleChanges
} from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'checkbox',
    templateUrl: 'checkbox.html',
    styleUrls: ['checkbox.css']
})
export class CheckBoxComponent implements OnInit,OnChanges {
    
    @Input() titolo: string ="";
    @Input() value: string ="";
    @Input() disabled: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() ngModelValue: boolean;
    @Input() labelSpace: boolean=false;
    
    innerValue: boolean = false;
    @Output() ngModelValueChange = new EventEmitter();
    @Output() OnChangeValue = new EventEmitter();
    ngOnInit(): void {

    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes && (changes["ngModelValue"])) {
            if (this.ngModelValue != null && this.ngModelValue != undefined) {               
                    this.innerValue = this.ngModelValue;
            }
            else this.innerValue = false;
        }
    }

    innerValueChange(e) {
        this.ngModelValueChange.emit(e);
        this.OnChangeValue.emit();
    }

}


// WEBPACK FOOTER //
// ./src/angular_library/components/checkbox/checkbox.component.ts